import {
  Drive,
  DriveItem,
  IdentitySet,
  ItemReference,
  List,
  ListItem,
  NullableOption,
  PublicationFacet,
  Site,
} from 'microsoft-graph';

export interface IDrive extends Drive {
  tenantId?: string;
}

export interface IDriveItem extends DriveItem {
  tenantId?: string;
}

export interface IDriveItemVersion {
  id?: string;
  lastModifiedDateTime?: string;
  '@microsoft.graph.downloadUrl'?: string;
}

export interface IList extends List {
  tenantId?: string;
}

export interface IListItem extends ListItem {
  tenantId?: string;
}

export const getLinkNameFromListItem = (item: IListItem): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fields: any = item.fields;

  if (fields && fields.LinkTitle) {
    return fields.LinkTitle;
  }

  if (fields && fields.Title) {
    return fields.Title;
  }

  return '';
};

export interface ISite extends Site {
  tenantId?: string;
}

export interface ISitePage {
  id?: string;
  name: string;
  title?: string;
  webUrl: string;
  tenantId?: string;
  parentReference?: NullableOption<ItemReference>;
  lastModifiedDateTime?: string;
  lastModifiedBy?: NullableOption<IdentitySet>;
  publishingState: PublicationFacet;
  pageLayout: string;
  canvasLayout?: ICanvasLayout;
}

export interface INewSitePage {
  '@odata.type': string;
  name: string;
  title: string;
  pageLayout: string;
  canvasLayout?: ICanvasLayout;
}

export interface IUpdateSitePage {
  '@odata.type': string;
  title?: string;
  canvasLayout?: ICanvasLayout;
}

export interface ICreateUploadSessionResponse {
  uploadUrl: string;
  expirationDateTime: string;
}

//
// SharePoint page layout and web part interfaces
//
export enum HorizontalSectionLayoutType {
  none = 'none',
  oneColumn = 'oneColumn',
  twoColumns = 'twoColumns',
  threeColumns = 'threeColumns',
  oneThirdLeftColumn = 'oneThirdLeftColumn',
  oneThirdRightColumn = 'oneThirdRightColumn',
  fullWidth = 'fullWidth',
  unknownFutureValue = 'unknownFutureValue',
}

export enum SectionEmphasisType {
  none = 'none',
  neutral = 'neutral',
  soft = 'soft',
  strong = 'strong',
  unknownFutureValue = 'unknownFutureValue',
}

export interface ICanvasLayout {
  horizontalSections?: IHorizontalSection[];
  verticalSection?: IVerticalSection;
  webParts?: IWebPart[]; //old structure of webparts in database
}

export interface IHorizontalSection {
  id?: string;
  layout: HorizontalSectionLayoutType;
  emphasis?: SectionEmphasisType;
  columns: IHorizontalSectionColumn[];
}

export interface IHorizontalSectionColumn {
  id?: string;
  width?: number;
  webparts: IWebPart[];
}

export interface IVerticalSection {
  id?: string;
  emphasis?: SectionEmphasisType;
  webparts: IWebPart[];
}

export enum IWebPartType {
  unknown = 0,
  text = 1,
  image = 2,
}

export interface IWebPart {
  '@odata.type': string;
  id?: string;
  internalType: IWebPartType;
}

export interface ITextWebPart extends IWebPart {
  innerHtml: string;
  updated?: boolean;
}

export interface IStandardWebPart extends IWebPart {
  webPartType?: string;
  data?: IWebPartData;
}

export interface IWebPartData {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  properties?: any; // This can be any type, depending on the web part
  serverProcessedContent?: IServerProcessedContent;
}

export interface IServerProcessedContent {
  imageSources?: IMetaDataKeyStringPair[];
}

export interface IMetaDataKeyStringPair {
  key?: string;
  value?: string;
}
